module.exports = "https://r.nearpod.com/assets/media/image/draw-it-cfa267b9f30d0866c8fcb5dc818741a8.svg";